import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  completeEmailVerification,
  authErrorMessage,
} from '../../../../shared/services/authService';
import ColourTextLogo from '../../../../colour_text_logo.svg';
import './LoginScreen.css';

const VerifyEmailScreen = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Firebase verification links carry an oobCode; `token` kept as legacy fallback.
  const [code] = useState(searchParams.get('oobCode') || searchParams.get('token') || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!code) return;
    let cancelled = false;

    const verify = async () => {
      setLoading(true);
      setError(null);
      try {
        await completeEmailVerification(code);
        if (cancelled) return;
        setSuccess(true);
        setTimeout(() => navigate('/login'), 3000);
      } catch (err) {
        console.error('Verification error:', err);
        if (!cancelled) {
          setError(authErrorMessage(err, 'Verification failed. Please try again.'));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    verify();
    return () => {
      cancelled = true;
    };
  }, [code, navigate]);

  return (
    <div className="login-screen">
      <div className="login-container">
        <div className="login-gradient-header"></div>
        <div className="login-card-content">
          <img src={ColourTextLogo} alt="Framework" className="login-logo" />
          <h1 className="login-title">Verify Your Email</h1>
          <p className="login-subtitle">
            {success
              ? 'Email verified successfully!'
              : loading
                ? 'Verifying your email…'
                : 'Please verify your email address to continue'}
          </p>

          {error && (
            <div className="login-error" role="alert">
              {error}
            </div>
          )}

          {!success && !code && (
            <p className="login-subtitle">
              Open the verification link from your email. If you need a new
              link, sign in and choose “Resend verification email”.
            </p>
          )}

          {success && (
            <p style={{ textAlign: 'center', color: '#2e7d32', fontFamily: "'Montserrat', sans-serif", fontSize: '14px', margin: '16px 0 0 0' }}>
              Redirecting to login page...
            </p>
          )}

          <div className="login-footer">
            <button
              type="button"
              className="toggle-mode-button"
              onClick={() => navigate('/login')}
              disabled={loading}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailScreen;
